const itemstore="CCBitemstore";

export function loadItems() {
    // load items from localstorage.   If not found, return empty object
    let items = JSON.parse(localStorage.getItem(itemstore));
    if (items == null) {
        return {};
    }


    // cycle through items and remove expired ones
    let deletedBenefits=false;
    let currentDate = new Date();
    currentDate.setHours(0,0,0,0);
    for (let key in items) {
        // console.log("checking card item: "+key+" for expired benefits");
        // console.log(items[key]);
        let deleteIndexes = [];
        items[key].benefits.forEach(function (benefit, index) {
            if (benefit === null) {
                deleteIndexes.push(index);
            } else {
                // console.log(benefit, index);
                if (benefit.expirationDate !== "") {
                    let expirationDate = new Date(benefit.expirationDate);
                    // console.log("checking expiration date: "+expirationDate + " compared to "+currentDate);
                    if (expirationDate < currentDate) {
                        deleteIndexes.push(index);
                    }
                }
            }
        });
        // console.log("delete indexes: "+deleteIndexes);
        if (deleteIndexes !== []) {
            deletedBenefits=true;
            for (let i=deleteIndexes.length-1; i>=0; i--) {
                // console.log("deleting "+deleteIndexes[i]);
                items[key].benefits.splice(deleteIndexes[i], 1);
            }
        }
    }
    if (deletedBenefits) {
        saveItems(items);
    }
    return items;
}

export function saveItems(items) {
    localStorage.setItem(itemstore, JSON.stringify(items));
}

export function saveItem(item) {
    let items = loadItems();
    // add item to items object with key item.shortname
    items[item.shortname] = item;
    saveItems(items);
}

export function getItem(shortname) {
    let items = loadItems();
    return items[shortname];
}

export function deleteItem(item) {
    let items = loadItems();
    console.log("deleting item: "+item.shortname);
    delete items[item.shortname];
    saveItems(items);
}

